module.exports = __webpack_public_path__ + "static/media/cricket-icon.53e3f03e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cricket-icon.svg
// module id = 38
// module chunks = 0